import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate, TextFormat, getPaginationState, JhiPagination, JhiItemCount } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './partenaire.reducer';

export const Partenaire = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const partenaireList = useAppSelector(state => state.partenaire.entities);
  const loading = useAppSelector(state => state.partenaire.loading);
  const totalItems = useAppSelector(state => state.partenaire.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    } else {
      return order === ASC ? faSortUp : faSortDown;
    }
  };

  return (
    <div>
      <h2 id="partenaire-heading" data-cy="PartenaireHeading">
        <Translate contentKey="alexisExportApp.partenaire.home.title">Partenaires</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="alexisExportApp.partenaire.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/partenaire/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="alexisExportApp.partenaire.home.createLabel">Create new Partenaire</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {partenaireList && partenaireList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="alexisExportApp.partenaire.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('nomOuRaisonSociale')}>
                  <Translate contentKey="alexisExportApp.partenaire.nomOuRaisonSociale">Nom Ou Raison Sociale</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('nomOuRaisonSociale')} />
                </th>
                <th className="hand" onClick={sort('tarifDeTransport')}>
                  <Translate contentKey="alexisExportApp.partenaire.tarifDeTransport">Tarif De Transport</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('tarifDeTransport')} />
                </th>
                <th className="hand" onClick={sort('datePersistence')}>
                  <Translate contentKey="alexisExportApp.partenaire.datePersistence">Date Persistence</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('datePersistence')} />
                </th>
                <th className="hand" onClick={sort('dateUpdate')}>
                  <Translate contentKey="alexisExportApp.partenaire.dateUpdate">Date Update</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dateUpdate')} />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {partenaireList.map((partenaire, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/partenaire/${partenaire.id}`} color="link" size="sm">
                      {partenaire.id}
                    </Button>
                  </td>
                  <td>{partenaire.nomOuRaisonSociale}</td>
                  <td>{partenaire.tarifDeTransport}</td>
                  <td>
                    {partenaire.datePersistence ? (
                      <TextFormat type="date" value={partenaire.datePersistence} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {partenaire.dateUpdate ? <TextFormat type="date" value={partenaire.dateUpdate} format={APP_DATE_FORMAT} /> : null}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/partenaire/${partenaire.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/partenaire/${partenaire.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/partenaire/${partenaire.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="alexisExportApp.partenaire.home.notFound">No Partenaires found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={partenaireList && partenaireList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Partenaire;
